import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { LoginAPI } from '../redux/actions/auth/LoginAction';
import { showSuccessToast, showErrorToast } from '../helpers/SweetAlert';
import { toast } from 'react-toastify';

const Login = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { login: contextLogin, isAuthenticated } = useContext(AuthContext);

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [validationErrors, setValidationErrors] = useState('');
    // const [errors, setErrors] = useState({ email: '', password: '' });

    const [isPasswordShown, setIsPasswordShown] = useState(false);

    const { response, loading, error } = useSelector((state) => state.login);

    // const validate = () => {
    //     let isValid = true;
    //     const newErrors = { email: '', password: '' };

    //     if (!email) {
    //         newErrors.email = 'Email is required';
    //         isValid = false;
    //     } else if (!/\S+@\S+\.\S+/.test(email)) {
    //         newErrors.email = 'Email is invalid';
    //         isValid = false;
    //     }

    //     if (!password) {
    //         newErrors.password = 'Password is required';
    //         isValid = false;
    //     }

    //     setErrors(newErrors);
    //     return isValid;
    // };

    const validateForm = useCallback(() => {
        const newErrors = {};

        if (!email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Enter a valid email address';
        }

        if (!password.trim()) {
            newErrors.password = 'Password is required';
        }

        setValidationErrors(newErrors);

        return Object.keys(newErrors).length === 0; // returns true if no errors
    }, [email, password]);

    const handleSubmit = useCallback(async (event) => {
        event.preventDefault();
        if (!validateForm()) {
            return;
        }
        try {
            dispatch(LoginAPI({ email, password }));
        } catch (error) {
            console.log(error);
        }

    }, [email, password, dispatch, validateForm]);

    const togglePasswordVisibility = useCallback(() => {
        setIsPasswordShown(prev => !prev);
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/admin-dashboard');
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        if (response?.status === true) {
            contextLogin(response?.data?.token);
            setEmail('');
            setPassword('');
            setValidationErrors('');
            showSuccessToast('Login successful!');
            navigate('/admin-dashboard');
        }
    }, [response, loading, contextLogin, navigate]);

    useEffect(() => {
        if (error) {
            toast.dismiss();
            showErrorToast(error.data, "error");
        }
    }, [error]);

    return (
        <section className="login-section">
            <div className="container-fluid g-0">
                <div className="row justify-content-center g-0">
                    <div className="col-md-7">
                        <div className="login-main-blk">
                            <div className="login-logo">
                                <Link to="/">
                                    <img src="/assets/images/Logo_transparent.png" alt="Matchmate" />
                                </Link>
                            </div>
                            <div className="login-form-blk">
                                <h1>Welcome back!</h1>
                                <p>Login to access all your data</p>
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group position-relative">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        {/* <input type="email" className={`form-control ${errors.email ? 'is-invalid' : 'is-valid'}`} id="email" placeholder="Enter your email address" value={email}
                                            onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => {
                                                if (e.key === ' ') {
                                                    e.preventDefault(); 
                                                }
                                            }} />
                                        {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>} */}

                                        <input type="email" className={`form-control ${validationErrors.email ? 'is-invalid' : ''}`} id="email" placeholder="Enter your email address" value={email} onChange={(e) => {
                                            const value = e.target.value;
                                            if (value.length === 1 && value === ' ') return;
                                            setEmail(value);
                                            if (validationErrors.email) {
                                                setValidationErrors(prev => ({ ...prev, email: false }));
                                            }
                                        }} />
                                        {validationErrors.email && (
                                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                                {validationErrors.email}
                                            </div>
                                        )}
                                    </div>
                                    <div className="form-group position-relative">
                                        <label htmlFor="password" className="form-label">Password</label>
                                        <div className="p-relative">
                                            {/* <input className={`form-control ${errors.password ? 'is-invalid' : 'is-valid'}`} id="password" type={isPasswordShown ? "text" : "password"} placeholder="Enter your password" value={password}
                                                onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => {
                                                    if (e.key === ' ') {
                                                        e.preventDefault();
                                                    }
                                                }} /> */}

                                            <input className={`form-control ${validationErrors.password ? 'is-invalid' : ''}`} id="password" placeholder="Enter your password" type={isPasswordShown ? "text" : "password"} value={password} onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.length === 1 && value === ' ') return;
                                                setPassword(value);
                                                if (validationErrors.password) {
                                                    setValidationErrors(prev => ({ ...prev, password: false }));
                                                }
                                            }} />
                                            <span id="eye" onClick={togglePasswordVisibility}>
                                                {isPasswordShown ? (
                                                    <i className="fa-solid fa-eye" id="eyeIcon"></i>
                                                ) : (
                                                    <i className="fa-solid fa-eye-slash" id="eyeIcon"></i>
                                                )}
                                            </span>

                                        </div>
                                        {validationErrors.password && (
                                            <div className="invalid-feedback" style={{ display: 'block' }}>
                                                {validationErrors.password}
                                            </div>
                                        )}
                                    </div>
                                    <div className='forgot_password'>
                                        <Link to="/forgot-password">Forgot Password?</Link>
                                    </div>
                                    <div className="login-btn-blk">
                                        <button type="submit" className="btn primary-btn">
                                            {/* {loading ? 'Logging in...' : 'Login'} */}Login
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Login;
